import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { get } from "lodash";
import { defaultDesingItems } from "utils/constants";

const { colors: c } = defaultDesingItems;

export const StyledRooms = styled(Box)`
  width: 100%;
  padding: 50px 0;
  color: #2d2d4b;

  h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #2d2d4b;
  }

  .nomers {
    display: flex;
    gap: 2px;
    border-bottom: 1px solid #2d2d4b;
    width: fit-content;

    .nomer {
      font-weight: 500;
      cursor: pointer;

      &:hover,
      &.active {
        background: white;
        .content {
          background: ${(props) => get(props, "design.colors.primary", c.primary) + "30"};
        }
      }

      .content {
        width: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        position: relative;
      }

      .check {
        position: absolute;
        bottom: 0;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: white;
        transform: translateY(50%);
        box-sizing: content-box;
        color: #e8e7f1 !important;

        &.active {
          border: 1px solid #2ecc71;
          color: #2ecc71 !important;
        }
      }
    }
  }

  .bookBtn {
    width: 120px;
    text-align: center;
    background: ${(props) => get(props, "design.colors.primary", c.primary)};
    color: ${(props) => get(props, "design.colors.button", c.button)};
    &:hover {
      background: ${(props) => get(props, "design.colors.primary", c.primary) + "80"};
    }
  }

  @media (max-width: 960px) {
    padding: 35px 0;
  }

  @media (max-width: 690px) {
    padding: 25px 0;
  }
`;
